<script>
    import FrontendHeader from '../components/FrontendHeader.svelte';
    import FrontendNav from '../components/FrontendNav.svelte';
    import FrontendMain from '../components/FrontendMain.svelte';
    import FrontendFooter from '../components/FrontendFooter.svelte';
    import { Menu as MenuIcon } from 'lucide-svelte';

    let isNavOpen = $state(true);
</script>

<div class="relative z-1 grid h-screen grid-cols-[auto_1fr]" id="FrontendLayout">
    <div
        class={`bg-dwc-200 border-black-200 flex flex-col
                 border-r-1 text-black transition-all duration-300
                 ${isNavOpen ? 'w-64' : 'w-18'}`}>
        <button class="bg-dwc-400 cursor-pointer space-y-2 px-4 py-3" onclick={() => (isNavOpen = !isNavOpen)}>
            <span class="flex items-center justify-start gap-3 rounded p-2">
                <MenuIcon class="shrink-0" size="24" />

                <span
                    class={`overflow-hidden transition-all duration-300
                              ${isNavOpen ? 'opacity-100' : 'opacity-0'}`}>
                    Menü
                </span>
            </span>
        </button>
        <FrontendNav {isNavOpen} />
    </div>

    <div class="flex h-screen flex-col overflow-hidden">
        <FrontendHeader />
        <FrontendMain />
        <FrontendFooter />
    </div>
</div>
